window.onload = (event) => {
  jQuery('.box').addClass('shown');
  jQuery('.langs').show();
};


jQuery(".langs span").click(function(){
  if(! jQuery(this).hasClass('actived') ){
    if(   jQuery(this).attr('id') == 'esp' ){

      jQuery(".boxb").toggleClass('outedb');
      jQuery(".box").toggleClass('outed');


      jQuery('#esp').addClass('actived');
      jQuery('#eng').removeClass('actived');
    }
    else{
      jQuery(".boxb").toggleClass('outedb');
      jQuery(".box").toggleClass('outed');

      jQuery('#esp').removeClass('actived');
      jQuery('#eng').addClass('actived');
    }
  }
});

        let sheets = [
        { name: 'one', id:'back'},
        { name: 'two', id: 'next'},
        { name: 'three', id: 'back'},
        { name: 'four', id: 'next'},
        { name: 'five', id: 'back'},
        { name: 'six', id: 'next'},
        { name: 'seven', id:'back'},
        { name: 'eight', id: 'next'},
        { name: 'nine', id: 'back'},
        { name: 'ten', id: 'next'},
        { name: 'eleven', id: 'back'},
        { name: 'twelve', id: 'next'},
        { name: 'thirteen', id:'back'},
        { name: 'fourteen', id: 'next'},
        { name: 'fifteen', id: 'back'},
        { name: 'sixteen', id: 'next'},
        { name: 'seventeen', id: 'back'},
        { name: 'eighteen', id: 'next'},
    ];
    
  
    


 












    let ongoingSheeta = 0,
    changinga = false;
    
    jQuery('.cookie-book').on('click', '.right, .left', function() {
      changea(jQuery(this).attr('data-id'));
    });
    
    function changea(flip) {
    if (changinga) return;
        
    if (flip != 'next' && flip != 'back') return;  
    let next_sheet = (flip == 'next'),
          switch_left_data = next_sheet ? sheets[ongoingSheeta + 2] : sheets[ongoingSheeta - 2],
          switch_right_data = next_sheet ? sheets[ongoingSheeta + 3] : sheets[ongoingSheeta - 1];
        
    if (!switch_left_data && !switch_right_data) return;
        
    changinga = true;
    let jQueryong_left = jQuery('.cookie-book .ongoing.left.sheet'),
        jQueryong_right = jQuery('.cookie-book .ongoing.right.sheet'),
        jQueryswitch_left = jQuery('<div class="left sheet ' + flip + '" />'),
        jQueryswitch_right = jQuery('<div class="right sheet ' + flip + '" />');
        
        if (switch_left_data) {
            jQueryswitch_left.addClass(switch_left_data.name);
            jQueryswitch_left.attr("data-id", switch_left_data.id);            
        }
        
        if (switch_right_data) {
            jQueryswitch_right.addClass(switch_right_data.name); 
            jQueryswitch_right.attr("data-id", switch_right_data.id);            
        }  
        
       
        jQuery('.cookie-book').append(jQueryswitch_left);
        jQuery('.cookie-book').append(jQueryswitch_right);
        
        jQueryong_left.addClass('to_remove');
        jQueryong_right.addClass('to_remove');
        
        setTimeout(function(){
            if (next_sheet) {
                jQueryong_right.addClass('move');
                jQueryswitch_left.addClass('move');
                var opensound = new Audio('https://cdn.shopify.com/s/files/1/0248/2975/5440/files/open.mp3'); opensound.volume = 0.25; opensound.play();
            }
            else {
                jQueryong_left.addClass('move');
                jQueryswitch_right.addClass('move');
                var closesound = new Audio('https://cdn.shopify.com/s/files/1/0248/2975/5440/files/close.mp3'); closesound.volume = 0.25; closesound.play();
            }
            
            jQueryswitch_left.addClass('ongoing');
            jQueryswitch_right.addClass('ongoing');
            
        }, 100);
        



        setTimeout(function(){
            jQuery('.cookie-book .sheet.to_remove').remove();
            jQuery('.cookie-book .sheet').removeClass('move next back'); 
            changinga = false;        
        }, 500);
        
        ongoingSheeta = next_sheet ? (ongoingSheeta + 2) : (ongoingSheeta - 2);
        if(ongoingSheeta == 0){ 
          setTimeout(function() { jQuery('.box .aopen').css('opacity', 0); jQuery('.box .aclose').css('opacity', 1); },  350);
        }
        else{ 
          setTimeout(function() { jQuery('.box .aopen').css('opacity', 1); jQuery('.box .aclose').css('opacity', 0); },  350); 
        }
    }

















    let ongoingSheetb = 0,
    changingb = false;
    
    jQuery('.aookie-book').on('click', '.right, .left', function() {
      changeb(jQuery(this).attr('data-id'));
    });
    
    function changeb(flip) {
    if (changingb) return;
        
    if (flip != 'next' && flip != 'back') return;  
    let next_sheet = (flip == 'next'),
          switch_left_data = next_sheet ? sheets[ongoingSheetb + 2] : sheets[ongoingSheetb - 2],
          switch_right_data = next_sheet ? sheets[ongoingSheetb + 3] : sheets[ongoingSheetb - 1];
        
    if (!switch_left_data && !switch_right_data) return;
        
    changingb = true;
    let jQueryong_left = jQuery('.aookie-book .ongoing.left.sheet'),
        jQueryong_right = jQuery('.aookie-book .ongoing.right.sheet'),
        jQueryswitch_left = jQuery('<div class="left sheet ' + flip + '" />'),
        jQueryswitch_right = jQuery('<div class="right sheet ' + flip + '" />');
        
        if (switch_left_data) {
            jQueryswitch_left.addClass(switch_left_data.name);
            jQueryswitch_left.attr("data-id", switch_left_data.id);
        }
        
        if (switch_right_data) {
            jQueryswitch_right.addClass(switch_right_data.name); 
            jQueryswitch_right.attr("data-id", switch_right_data.id);
        }  
        
        jQuery('.aookie-book').append(jQueryswitch_left);
        jQuery('.aookie-book').append(jQueryswitch_right);
        
        jQueryong_left.addClass('to_remove');
        jQueryong_right.addClass('to_remove');
        
        setTimeout(function(){
            if (next_sheet) {
                jQueryong_right.addClass('move');
                jQueryswitch_left.addClass('move');
                var opensound = new Audio('https://cdn.shopify.com/s/files/1/0248/2975/5440/files/open.mp3'); opensound.volume = 0.25; opensound.play();
            }
            else {
                jQueryong_left.addClass('move');
                jQueryswitch_right.addClass('move');
                var closesound = new Audio('https://cdn.shopify.com/s/files/1/0248/2975/5440/files/close.mp3'); closesound.volume = 0.25; closesound.play();
            }
            
            jQueryswitch_left.addClass('ongoing');
            jQueryswitch_right.addClass('ongoing');
            
        }, 100);
        
        setTimeout(function(){
            jQuery('.aookie-book .sheet.to_remove').remove();
            jQuery('.aookie-book .sheet').removeClass('move next back'); 
            changingb = false;        
        }, 500);
        
        ongoingSheetb = next_sheet ? (ongoingSheetb + 2) : (ongoingSheetb - 2);
        if(ongoingSheetb == 0){ 
          setTimeout(function() { jQuery('.box .bopen').css('opacity', 0); jQuery('.box .bclose').css('opacity', 1); },  350);
        }
        else{ 
          setTimeout(function() { jQuery('.box .bopen').css('opacity', 1); jQuery('.box .bclose').css('opacity', 0); },  350); 
        }
    }














    let ongoingSheetc = 0,
    changingc = false;
    
    jQuery('.bookie-book').on('click', '.right, .left', function() {
      changec(jQuery(this).attr('data-id'));
    });
    
    function changec(flip) {
    if (changingc) return;
        
    if (flip != 'next' && flip != 'back') return;  
    let next_sheet = (flip == 'next'),
          switch_left_data = next_sheet ? sheets[ongoingSheetc + 2] : sheets[ongoingSheetc - 2],
          switch_right_data = next_sheet ? sheets[ongoingSheetc + 3] : sheets[ongoingSheetc - 1];
        
    if (!switch_left_data && !switch_right_data) return;
        
    changingc = true;
    let jQueryong_left = jQuery('.bookie-book .ongoing.left.sheet'),
        jQueryong_right = jQuery('.bookie-book .ongoing.right.sheet'),
        jQueryswitch_left = jQuery('<div class="left sheet ' + flip + '" />'),
        jQueryswitch_right = jQuery('<div class="right sheet ' + flip + '" />');
        
        if (switch_left_data) {
            jQueryswitch_left.addClass(switch_left_data.name);
            jQueryswitch_left.attr("data-id", switch_left_data.id);
        }
        
        if (switch_right_data) {
            jQueryswitch_right.addClass(switch_right_data.name); 
            jQueryswitch_right.attr("data-id", switch_right_data.id);
        }  
        
        jQuery('.bookie-book').append(jQueryswitch_left);
        jQuery('.bookie-book').append(jQueryswitch_right);
        
        jQueryong_left.addClass('to_remove');
        jQueryong_right.addClass('to_remove');
        
        setTimeout(function(){
            if (next_sheet) {
                jQueryong_right.addClass('move');
                jQueryswitch_left.addClass('move');
                var opensound = new Audio('https://cdn.shopify.com/s/files/1/0248/2975/5440/files/open.mp3'); opensound.volume = 0.25; opensound.play();
            }
            else {
                jQueryong_left.addClass('move');
                jQueryswitch_right.addClass('move');
                var closesound = new Audio('https://cdn.shopify.com/s/files/1/0248/2975/5440/files/close.mp3'); closesound.volume = 0.25; closesound.play();
            }
            
            jQueryswitch_left.addClass('ongoing');
            jQueryswitch_right.addClass('ongoing');
            
        }, 100);
        
        setTimeout(function(){
            jQuery('.bookie-book .sheet.to_remove').remove();
            jQuery('.bookie-book .sheet').removeClass('move next back'); 
            changingc = false;        
        }, 500);
        
        ongoingSheetc = next_sheet ? (ongoingSheetc + 2) : (ongoingSheetc - 2);
        if(ongoingSheetc == 0){ 
          setTimeout(function() { jQuery('.box .copen').css('opacity', 0); jQuery('.box .cclose').css('opacity', 1); },  350);
        }
        else{ 
          setTimeout(function() { jQuery('.box .copen').css('opacity', 1); jQuery('.box .cclose').css('opacity', 0); },  350); 
        }
    }








    let ongoingSheetd = 0,
    changingd = false;
    
    jQuery('.dookie-book').on('click', '.right, .left', function() {
      changed(jQuery(this).attr('data-id'));
    });
    
    function changed(flip) {
    if (changingd) return;
        
    if (flip != 'next' && flip != 'back') return;  
    let next_sheet = (flip == 'next'),
          switch_left_data = next_sheet ? sheets[ongoingSheetd + 2] : sheets[ongoingSheetd - 2],
          switch_right_data = next_sheet ? sheets[ongoingSheetd + 3] : sheets[ongoingSheetd - 1];
        
    if (!switch_left_data && !switch_right_data) return;
        
    changingd = true;
    let jQueryong_left = jQuery('.dookie-book .ongoing.left.sheet'),
        jQueryong_right = jQuery('.dookie-book .ongoing.right.sheet'),
        jQueryswitch_left = jQuery('<div class="left sheet ' + flip + '" />'),
        jQueryswitch_right = jQuery('<div class="right sheet ' + flip + '" />');
        
        if (switch_left_data) {
            jQueryswitch_left.addClass(switch_left_data.name);
            jQueryswitch_left.attr("data-id", switch_left_data.id);
        }
        
        if (switch_right_data) {
            jQueryswitch_right.addClass(switch_right_data.name); 
            jQueryswitch_right.attr("data-id", switch_right_data.id);
        }  
        
        jQuery('.dookie-book').append(jQueryswitch_left);
        jQuery('.dookie-book').append(jQueryswitch_right);
        
        jQueryong_left.addClass('to_remove');
        jQueryong_right.addClass('to_remove');
        
        setTimeout(function(){
            if (next_sheet) {
                jQueryong_right.addClass('move');
                jQueryswitch_left.addClass('move');
                var opensound = new Audio('https://cdn.shopify.com/s/files/1/0248/2975/5440/files/open.mp3'); opensound.volume = 0.25; opensound.play();
            }
            else {
                jQueryong_left.addClass('move');
                jQueryswitch_right.addClass('move');
                var closesound = new Audio('https://cdn.shopify.com/s/files/1/0248/2975/5440/files/close.mp3'); closesound.volume = 0.25; closesound.play();
            }
            
            jQueryswitch_left.addClass('ongoing');
            jQueryswitch_right.addClass('ongoing');
            
        }, 100);
        
        setTimeout(function(){
            jQuery('.dookie-book .sheet.to_remove').remove();
            jQuery('.dookie-book .sheet').removeClass('move next back'); 
            changingd = false;        
        }, 500);
        
        ongoingSheetd = next_sheet ? (ongoingSheetd + 2) : (ongoingSheetd - 2);
        if(ongoingSheetd == 0){ 
          setTimeout(function() { jQuery('.box .dopen').css('opacity', 0); jQuery('.box .dclose').css('opacity', 1); },  350);
        }
        else{ 
          setTimeout(function() { jQuery('.box .dopen').css('opacity', 1); jQuery('.box .dclose').css('opacity', 0); },  350); 
        }
    }












    

    let ongoingSheetw = 0,
    changingw = false;
    
    jQuery('.wookie-book').on('click', '.right, .left', function() {
      changew(jQuery(this).attr('data-id'));
    });
    
    function changew(flip) {
    if (changingw) return;
        
    if (flip != 'next' && flip != 'back') return;  
    let next_sheet = (flip == 'next'),
          switch_left_data = next_sheet ? sheets[ongoingSheetw + 2] : sheets[ongoingSheetw - 2],
          switch_right_data = next_sheet ? sheets[ongoingSheetw + 3] : sheets[ongoingSheetw - 1];
        
    if (!switch_left_data && !switch_right_data) return;
        
    changingw = true;
    let jQueryong_left = jQuery('.wookie-book .ongoing.left.sheet'),
        jQueryong_right = jQuery('.wookie-book .ongoing.right.sheet'),
        jQueryswitch_left = jQuery('<div class="left sheet ' + flip + '" />'),
        jQueryswitch_right = jQuery('<div class="right sheet ' + flip + '" />');
        
        if (switch_left_data) {
            jQueryswitch_left.addClass(switch_left_data.name);
            jQueryswitch_left.attr("data-id", switch_left_data.id);            
        }
        
        if (switch_right_data) {
            jQueryswitch_right.addClass(switch_right_data.name); 
            jQueryswitch_right.attr("data-id", switch_right_data.id);            
        }  
        
        jQuery('.wookie-book').append(jQueryswitch_left);
        jQuery('.wookie-book').append(jQueryswitch_right);
        
        jQueryong_left.addClass('to_remove');
        jQueryong_right.addClass('to_remove');
        
        setTimeout(function(){
            if (next_sheet) {
                jQueryong_right.addClass('move');
                jQueryswitch_left.addClass('move');
                var opensound = new Audio('https://cdn.shopify.com/s/files/1/0248/2975/5440/files/open.mp3'); opensound.volume = 0.25; opensound.play();
            }
            else {
                jQueryong_left.addClass('move');
                jQueryswitch_right.addClass('move');
                var closesound = new Audio('https://cdn.shopify.com/s/files/1/0248/2975/5440/files/close.mp3'); closesound.volume = 0.25; closesound.play();
            }
            
            jQueryswitch_left.addClass('ongoing');
            jQueryswitch_right.addClass('ongoing');
            
        }, 100);
        
        setTimeout(function(){
            jQuery('.wookie-book .sheet.to_remove').remove();
            jQuery('.wookie-book .sheet').removeClass('move next back'); 
            changingw = false;        
        }, 500);
        
        ongoingSheetw = next_sheet ? (ongoingSheetw + 2) : (ongoingSheetw - 2);
        if(ongoingSheetw == 0){ 
          setTimeout(function() { jQuery('.boxb .aopen').css('opacity', 0); jQuery('.boxb .aclose').css('opacity', 1); },  350);
        }
        else{ 
          setTimeout(function() { jQuery('.boxb .aopen').css('opacity', 1); jQuery('.boxb .aclose').css('opacity', 0); },  350); 
        }
    }

















    let ongoingSheetx = 0,
    changingx = false;
    
    jQuery('.xookie-book').on('click', '.right, .left', function() {
      changex(jQuery(this).attr('data-id'));
    });
    
    function changex(flip) {
    if (changingx) return;
        
    if (flip != 'next' && flip != 'back') return;  
    let next_sheet = (flip == 'next'),
          switch_left_data = next_sheet ? sheets[ongoingSheetx + 2] : sheets[ongoingSheetx - 2],
          switch_right_data = next_sheet ? sheets[ongoingSheetx + 3] : sheets[ongoingSheetx - 1];
        
    if (!switch_left_data && !switch_right_data) return;
        
    changingx = true;
    let jQueryong_left = jQuery('.xookie-book .ongoing.left.sheet'),
        jQueryong_right = jQuery('.xookie-book .ongoing.right.sheet'),
        jQueryswitch_left = jQuery('<div class="left sheet ' + flip + '" />'),
        jQueryswitch_right = jQuery('<div class="right sheet ' + flip + '" />');
        
        if (switch_left_data) {
            jQueryswitch_left.addClass(switch_left_data.name);
            jQueryswitch_left.attr("data-id", switch_left_data.id);
        }
        
        if (switch_right_data) {
            jQueryswitch_right.addClass(switch_right_data.name); 
            jQueryswitch_right.attr("data-id", switch_right_data.id);
        }  
        
        jQuery('.xookie-book').append(jQueryswitch_left);
        jQuery('.xookie-book').append(jQueryswitch_right);
        
        jQueryong_left.addClass('to_remove');
        jQueryong_right.addClass('to_remove');
        
        setTimeout(function(){
            if (next_sheet) {
                jQueryong_right.addClass('move');
                jQueryswitch_left.addClass('move');
                var opensound = new Audio('https://cdn.shopify.com/s/files/1/0248/2975/5440/files/open.mp3'); opensound.volume = 0.25; opensound.play();
            }
            else {
                jQueryong_left.addClass('move');
                jQueryswitch_right.addClass('move');
                var closesound = new Audio('https://cdn.shopify.com/s/files/1/0248/2975/5440/files/close.mp3'); closesound.volume = 0.25; closesound.play();
            }
            
            jQueryswitch_left.addClass('ongoing');
            jQueryswitch_right.addClass('ongoing');
            
        }, 100);
        
        setTimeout(function(){
            jQuery('.xookie-book .sheet.to_remove').remove();
            jQuery('.xookie-book .sheet').removeClass('move next back'); 
            changingx = false;        
        }, 500);
        
        ongoingSheetx = next_sheet ? (ongoingSheetx + 2) : (ongoingSheetx - 2);
        if(ongoingSheetx == 0){ 
          setTimeout(function() { jQuery('.boxb .bopen').css('opacity', 0); jQuery('.boxb .bclose').css('opacity', 1); },  350);
        }
        else{ 
          setTimeout(function() { jQuery('.boxb .bopen').css('opacity', 1); jQuery('.boxb .bclose').css('opacity', 0); },  350); 
        }
    }














    let ongoingSheety= 0,
    changingy = false;
    
    jQuery('.yookie-book').on('click', '.right, .left', function() {
      changey(jQuery(this).attr('data-id'));
    });
    
    function changey(flip) {
    if (changingy) return;
        
    if (flip != 'next' && flip != 'back') return;  
    let next_sheet = (flip == 'next'),
          switch_left_data = next_sheet ? sheets[ongoingSheety + 2] : sheets[ongoingSheety - 2],
          switch_right_data = next_sheet ? sheets[ongoingSheety + 3] : sheets[ongoingSheety - 1];
        
    if (!switch_left_data && !switch_right_data) return;
        
    changingy = true;
    let jQueryong_left = jQuery('.yookie-book .ongoing.left.sheet'),
        jQueryong_right = jQuery('.yookie-book .ongoing.right.sheet'),
        jQueryswitch_left = jQuery('<div class="left sheet ' + flip + '" />'),
        jQueryswitch_right = jQuery('<div class="right sheet ' + flip + '" />');
        
        if (switch_left_data) {
            jQueryswitch_left.addClass(switch_left_data.name);
            jQueryswitch_left.attr("data-id", switch_left_data.id);
        }
        
        if (switch_right_data) {
            jQueryswitch_right.addClass(switch_right_data.name); 
            jQueryswitch_right.attr("data-id", switch_right_data.id);
        }  
        
        jQuery('.yookie-book').append(jQueryswitch_left);
        jQuery('.yookie-book').append(jQueryswitch_right);
        
        jQueryong_left.addClass('to_remove');
        jQueryong_right.addClass('to_remove');
        
        setTimeout(function(){
            if (next_sheet) {
                jQueryong_right.addClass('move');
                jQueryswitch_left.addClass('move');
                var opensound = new Audio('https://cdn.shopify.com/s/files/1/0248/2975/5440/files/open.mp3'); opensound.volume = 0.25; opensound.play();
            }
            else {
                jQueryong_left.addClass('move');
                jQueryswitch_right.addClass('move');
                var closesound = new Audio('https://cdn.shopify.com/s/files/1/0248/2975/5440/files/close.mp3'); closesound.volume = 0.25; closesound.play();
            }
            
            jQueryswitch_left.addClass('ongoing');
            jQueryswitch_right.addClass('ongoing');
            
        }, 100);
        
        setTimeout(function(){
            jQuery('.yookie-book .sheet.to_remove').remove();
            jQuery('.yookie-book .sheet').removeClass('move next back'); 
            changingy = false;        
        }, 500);
        
        ongoingSheety = next_sheet ? (ongoingSheety + 2) : (ongoingSheety - 2);
        if(ongoingSheety == 0){ 
          setTimeout(function() { jQuery('.boxb .copen').css('opacity', 0); jQuery('.boxb .cclose').css('opacity', 1); },  350);
        }
        else{ 
          setTimeout(function() { jQuery('.boxb .copen').css('opacity', 1); jQuery('.boxb .cclose').css('opacity', 0); },  350); 
        }
    }








    let ongoingSheetz = 0,
    changingz = false;
    
    jQuery('.zookie-book').on('click', '.right, .left', function() {
      changez(jQuery(this).attr('data-id'));
    });
    
    function changez(flip) {
    if (changingz) return;
        
    if (flip != 'next' && flip != 'back') return;  
    let next_sheet = (flip == 'next'),
          switch_left_data = next_sheet ? sheets[ongoingSheetz + 2] : sheets[ongoingSheetz - 2],
          switch_right_data = next_sheet ? sheets[ongoingSheetz + 3] : sheets[ongoingSheetz - 1];
        
    if (!switch_left_data && !switch_right_data) return;
        
    changingz = true;
    let jQueryong_left = jQuery('.zookie-book .ongoing.left.sheet'),
        jQueryong_right = jQuery('.zookie-book .ongoing.right.sheet'),
        jQueryswitch_left = jQuery('<div class="left sheet ' + flip + '" />'),
        jQueryswitch_right = jQuery('<div class="right sheet ' + flip + '" />');
        
        if (switch_left_data) {
            jQueryswitch_left.addClass(switch_left_data.name);
            jQueryswitch_left.attr("data-id", switch_left_data.id);
        }
        
        if (switch_right_data) {
            jQueryswitch_right.addClass(switch_right_data.name); 
            jQueryswitch_right.attr("data-id", switch_right_data.id);
        }  
        
        jQuery('.zookie-book').append(jQueryswitch_left);
        jQuery('.zookie-book').append(jQueryswitch_right);
        
        jQueryong_left.addClass('to_remove');
        jQueryong_right.addClass('to_remove');
        
        setTimeout(function(){
            if (next_sheet) {
                jQueryong_right.addClass('move');
                jQueryswitch_left.addClass('move');
                var opensound = new Audio('https://cdn.shopify.com/s/files/1/0248/2975/5440/files/open.mp3'); opensound.volume = 0.25; opensound.play();
            }
            else {
                jQueryong_left.addClass('move');
                jQueryswitch_right.addClass('move');
                var closesound = new Audio('https://cdn.shopify.com/s/files/1/0248/2975/5440/files/close.mp3'); closesound.volume = 0.25; closesound.play();
            }
            
            jQueryswitch_left.addClass('ongoing');
            jQueryswitch_right.addClass('ongoing');
            
        }, 100);
        
        setTimeout(function(){
            jQuery('.zookie-book .sheet.to_remove').remove();
            jQuery('.zookie-book .sheet').removeClass('move next back'); 
            changingz = false;        
        }, 500);
        
        ongoingSheetz = next_sheet ? (ongoingSheetz + 2) : (ongoingSheetz - 2);
        if(ongoingSheetz == 0){ 
          setTimeout(function() { jQuery('.boxb .dopen').css('opacity', 0); jQuery('.boxb .dclose').css('opacity', 1); },  350);
        }
        else{ 
          setTimeout(function() { jQuery('.boxb .dopen').css('opacity', 1); jQuery('.boxb .dclose').css('opacity', 0); },  350); 
        }
    }


